import {
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from "../../ui/tooltip";
import { TooltipProps } from "./types";

export const Tooltip = ({
  children,
  content,
  providerProps = {},
  triggerProps = {},
  contentProps = {},
}: TooltipProps) => {
  return (
    <TooltipProvider {...providerProps}>
      <TooltipRoot>
        <TooltipTrigger {...triggerProps}>{children}</TooltipTrigger>
        {content && (
          <TooltipContent {...contentProps}>{content}</TooltipContent>
        )}
      </TooltipRoot>
    </TooltipProvider>
  );
};
